const colors = {
    white: '#fff',
    tifanny: '#0ABAB5',
    outerSpace: '#1B2828',
    congressBlue: '#024A81',
};

export { colors };